import { useState } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Dashboard = ({
  sidebarLinks,
  children,
  cartIcon,
  navLinks,
  profileTitle,
  navBarTitle,
  notificationCount,
}) => {
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const toggleSideBar = () => setIsSideBarOpen((prev) => !prev);
  return (
    <>
      <Navbar
        toggleMenu={toggleSideBar}
        children={cartIcon}
        menuStatus={isSideBarOpen}
        navLinks={navLinks}
        title={navBarTitle}
         notificationCount={ notificationCount}
        profileTitle={profileTitle}
      />

      <div className="flex gap-0">
        <Sidebar
          sidebarLinks={sidebarLinks}
          profileTitle={profileTitle}
          menuStatus={isSideBarOpen}
          toggleMenu={toggleSideBar}
        />
        <main className=" w-full mt-[50px] md:mt-[60px] min-h-[100vh] h-full md:l-0 overflow-hidden">
          {children}
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Dashboard;
